
import { map, Observable } from 'rxjs';

import { ChipModel } from '../../Forms/models/chip.model';
import { FilterTypesEnum } from '../enums/filters-types.enum';
import { FilterTypeModel } from './abstract-filter-type.model';
import { FilterOptionModel } from './filter-option.model';
import { FilterQuickOptionModel } from './filter-quick-option.model';
import { IncludeExcludeEnum } from '../enums/include-exclude.enum';

export class FilterTypeAutocompleteModel<T = any> extends FilterTypeModel<FilterOptionModel<T>[]> {
    readonly key: FilterTypesEnum = FilterTypesEnum.autocomplete;

    autocompleteOptions: (query: string) => Observable<FilterOptionModel<T>[]>;

    protected value: FilterOptionModel<T>[];
    protected currentValue: FilterOptionModel<T>[];

    constructor(
        id: string,
        label: string,
        autocompleteOptions: (query: string) => Observable<FilterOptionModel<T>[]>,
        value?: FilterOptionModel<T>[],
        section?: string,
        showIncludeExclude?: boolean
    ) {
        super(id, label, section, showIncludeExclude);

        this.autocompleteOptions = autocompleteOptions;
        this.setValue(value || []);
    }

    setValue(value: FilterOptionModel<T>[]): void {
        this.value = value;
        this.chips = this.value;
        this.cancelChanges();
        this.updateChipSuffix();
    }
    getValue(): FilterOptionModel<T>[] {
        return this.value;
    }
    removeChip(chip: ChipModel): void {
        this.setValue(this.value.filter(valueChip => valueChip !== chip));
    }
    clear(): void {
        this.setValue([]);
        this.setIncludeExclude(IncludeExcludeEnum.include);
    }
    setCurrentValue(value: FilterOptionModel<T>[]): void {
        this.currentValue = value;
        this.currentChips = this.currentValue;
        this.updateCurrentChipSuffix();
    }
    getCurrentValue(): FilterOptionModel<T>[] {
        return this.currentValue;
    }
    cancelChanges(): void {
        this.currentValue = this.value.slice();
        this.currentChips = this.currentValue;
    }
    removeCurrentChip(chip: ChipModel): void {
        this.setCurrentValue(this.currentValue.filter(valueChip => valueChip !== chip));
    }

    quickAutocomplete(query: string, translateMethod: (str: string) => string): Observable<FilterQuickOptionModel<FilterOptionModel<T>>[]> {
        return this.autocompleteOptions(query).pipe(map(options => {
            return options.map(opt => {
                return {
                    label: opt.label,
                    value: opt,
                    filter: this
                };
            });
        }));
    }
    addQuickOption(option: FilterQuickOptionModel<FilterOptionModel<T>>): void {
        this.setValue([...this.value, option.value]);
    }
}
